import {useState, useRef, useEffect, useCallback} from "react";
import Form, {ButtonItem, GroupItem, RequiredRule, SimpleItem} from "devextreme-react/form";
import {useSnackbar} from "notistack";
import {db} from "../../../../firebase/Firebase";
import {ErrorMessage, NotiStackInfo} from "../../../../palette/NotiStackInfo";
import {FormContainer} from "../../../../palette/Palette";
import HeaderPage from "../../../../palette/HeaderPage";
import {buttonSuccess} from "../../../../utils/ComponentsSetting";
import './settings.css'
import {Button} from "devextreme-react/button";
import VerticalSpace from "../../../../palette/VerticalSpace";
import Alerts from "../../../../palette/Alerts";
import {Filters} from "../../../../utils/HelpFunctions";
import {cities, days} from "../../../../utils/Utils";
import format from 'date-fns/format'

const data = {
    routeName: "",
    origin: '',
    destination: '',
    travelTime: null,
    breakTime: null,
    rate: null,
    commissionRate: null,
    days: null,
    hour: null
}

const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true

        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}

function RoutesSchedulesForm(props) {

    const {trigger, setTrigger, DataStore, setVisibleForm, setVisibleGrid, dataSource} = props

    const {companyName, idCompany,} = DataStore

    const [submitButton, setSubmitButton] = useState({...buttonSuccess, text: 'Agregar horario'})
    const [load, setLoad] = useState(true)
    const [routes, setRoutes] = useState([])
    const [newRoutes, setNewRoutes] = useState({origin: null, destination: null,})
    const [dataRoutes, setDataRoutes] = useState(null)
    const [valueRoutes, setValueRoutes] = useState("")
    const [alert, setAlert] = useState(false)
    const [success, setSuccess] = useState(false)

    const {enqueueSnackbar} = useSnackbar();
    const dxForm = useRef(null);
    const isMounted = useMountedState()

    useEffect(() => {
        if (isMounted()) {
            setDataRoutes({...data})
        }
    }, [isMounted])

    useEffect(() => {
        const GetRoutes = async () => {
            const routesArray = []
            await db.collection(companyName).doc(idCompany).collection('Data-Routes').get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        routesArray.push(doc.data().routeName)
                    });
                    const newArr = routesArray.filter((el, index) => routesArray.indexOf(el) === index)
                    setRoutes(newArr)
                })

        }
        if (isMounted()) {
            GetRoutes().catch(() => NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar))
        }
    }, [companyName, enqueueSnackbar, idCompany, isMounted, trigger])

    const destinationOptions = {
        items: cities,
        searchEnabled: true,
        value: dataRoutes?.destination,
        placeholder: 'Seleccionar...',
        onItemClick: (e) => onNewValueChanged('destination', e)
    }

    const originOptions = {
        items: cities,
        searchEnabled: true,
        value: dataRoutes?.origin,
        placeholder: 'Seleccionar...',
        onItemClick: (e) => onNewValueChanged('origin', e)
    }

    const renderCancelButton = () => {
        const {instance} = dxForm.current
        return (
            <Button id="cancel-button"
                    icon="fas fa-ban"
                    text="Cancelar"
                    onClick={() => {
                        instance.resetValues()
                        setVisibleForm(false)
                        setVisibleGrid(true)
                    }}/>
        )
    }

    const renderAlert = () => {
        return (
            <Alerts severity={'warning'}
                    body={`Ya existe un horario el dia ${dataRoutes.days} a las  ${format(dataRoutes.hour, 'HH:mm')}`}/>
        )
    }

    const renderSuccess = () => {
        return (<Alerts severity="success" body={'Ruta creada creada exitosamente'}/>
        )
    }

    const onNewValueChanged = (key, e) => {
        // const obj = selectRoute ? {...newRoutes} : {...newRoutes, [key]: e.itemData}
        const obj = {...newRoutes, [key]: e.itemData}
        setNewRoutes({...obj})
        if (obj.origin && obj.destination) {
            const dataRoute = `${obj.origin}-${obj.destination}`
            const result = routes.filter(routes => routes === dataRoute);
            setRoutes(result)
        }

        if (dataRoutes.origin !== '' && obj.destination && !alert) {
            const dataRoute = `${dataRoutes.origin}-${obj.destination}`
            const result = routes.filter(routes => routes === dataRoute);
            setRoutes(result)
            setDataRoutes({
                ...dataRoutes, travelTime: null,
                breakTime: null,
                rate: null,
                commissionRate: null,
                days: null,
                hour: null
            })
        }

        if (dataRoutes.destination !== '' && obj.origin && !alert) {
            const dataRoute = `${dataRoutes.origin}-${obj.destination}`
            const result = routes.filter(routes => routes === dataRoute);
            setRoutes(result)
            setDataRoutes({
                ...dataRoutes, travelTime: null,
                breakTime: null,
                rate: null,
                commissionRate: null,
                days: null,
                hour: null
            })
        }
    }

    const onValueRoutesChanged = async (e) => {
        if (e.value) {
            setValueRoutes(e.value)
            await db.collection(companyName).doc(idCompany).collection('Data-Routes').doc(e.value).get()
                .then((doc) => {
                    if (doc.exists) {
                        setDataRoutes({...doc.data()})
                    } else {
                        setDataRoutes({...data})
                    }
                }).catch(() => {
                    NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                })
        }
    }

    const controlHours = () => {
        if (dataRoutes.hour && dataRoutes.days) {
            const dataRoute = `${dataRoutes.origin}-${dataRoutes.destination}`
            const getRoute = Filters(dataSource, 'routeName', dataRoute)
            const formatHour = format(dataRoutes.hour, 'HH:mm')
            const getDays = Filters(getRoute, 'days', dataRoutes.days)
            const controlHours = Filters(getDays, 'hour', formatHour)
            if (controlHours.length > 0) {
                setAlert(true)
            } else {
                setAlert(false)
            }
        } else {
            setAlert(false)
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        const formatHour = format(dataRoutes.hour, 'HH:mm')

        setSubmitButton({...submitButton, text: 'Agregando...', disabled: true})

        const {instance} = dxForm.current
        setLoad(false)

        let dataRouteName = ""
        if (routes.length === 0) {
            dataRouteName = `${dataRoutes.origin}-${dataRoutes.destination}`
            setValueRoutes(dataRouteName)
        } else {
            dataRouteName = valueRoutes
        }

        const getRoute = Filters(dataSource, 'routeName', dataRouteName)
        const getDays = Filters(getRoute, 'days', dataRoutes.days)
        const controlHours = Filters(getDays, 'hour', formatHour)

        const hour = formatHour.toLocaleString()

        const newData = {...dataRoutes, hour: hour, routeName: dataRouteName}

        const newDataRoutes = {...dataRoutes, hour: null, days: null, routeName: dataRouteName}

        if (controlHours.length === 0) {

            await db.collection(companyName).doc(idCompany).collection('Routes').doc().set(newData)
                .then(async () => {
                    const dataRoutesRef = db.collection(companyName).doc(idCompany).collection('Data-Routes').doc(dataRouteName)
                    await dataRoutesRef.get().then(async (doc) => {
                        if (doc.exists) {
                            setSuccess(true)
                            setTrigger(!trigger)
                            setLoad(true)
                            setTimeout(() => {
                                instance.resetValues()
                                setVisibleForm(false)
                                setVisibleGrid(true)
                                setSuccess(false)
                                setSubmitButton({...submitButton, text: 'Agregar horario', disabled: false})
                                setDataRoutes({
                                    ...dataRoutes,
                                    days: null,
                                    hour: null
                                })
                            }, 2000)
                        } else {
                            await dataRoutesRef.set(newDataRoutes)
                                .then(async () => {
                                    setSuccess(true)
                                    setTrigger(!trigger)
                                    setLoad(true)
                                    setTimeout(() => {
                                        instance.resetValues()
                                        setSuccess(false)
                                        setVisibleForm(false)
                                        setVisibleGrid(true)
                                        setSubmitButton({...submitButton, text: 'Agregar horario', disabled: false})
                                    }, 2500)
                                })
                        }
                    })
                }).catch(() => {
                    NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                    setSubmitButton({...submitButton, text: 'Agregar horario', disabled: false})
                })


        } else {
            setAlert(true)
        }

    }

    return (
        <>
            <VerticalSpace space={30}/>
            <div className="routes-schedules-form">
                <HeaderPage icon={'far fa-list-alt'} text={'Rutas y horarios'} load={load}
                            textLoad={'Guardando....'}/>
                <FormContainer>
                    <form action="" onSubmit={handleSubmit} method="POST">
                        <Form
                            ref={dxForm}
                            formData={dataRoutes}
                            readOnly={false}
                            showColonAfterLabel={true}
                            validationGroup="create-schedule"
                        >
                            {routes.length > 0 && <GroupItem colCount={1} caption={'Datos'}>
                                <SimpleItem dataField="routeName" label={{text: 'Nombre de la ruta'}}
                                            editorType="dxSelectBox"
                                            editorOptions={{
                                                items: routes,
                                                searchEnabled: true,
                                                placeholder: 'Seleccionar...',
                                                noDataText: 'No existe ruta',
                                                value: valueRoutes,
                                                onValueChanged: onValueRoutesChanged
                                            }}>
                                </SimpleItem>
                            </GroupItem>}
                            <GroupItem caption={routes.length > 0 ? '' : 'Datos'} colCount={2}>
                                <SimpleItem dataField="origin" label={{text: 'Origen'}} editorType="dxSelectBox"
                                            editorOptions={originOptions}>
                                    <RequiredRule message="Seleccione el origen"/>
                                </SimpleItem>

                                <SimpleItem dataField="destination" label={{text: 'Destino'}} editorType="dxSelectBox"
                                            editorOptions={destinationOptions}>
                                    <RequiredRule message="Seleccione el destino"/>
                                </SimpleItem>


                                <SimpleItem dataField="travelTime" label={{text: 'Tiempo estimado de viaje'}}
                                            editorType="dxNumberBox" editorOptions={{placeholder: 'Minutos'}}>
                                    <RequiredRule message="Ingrese el tiempo de viaje"/>
                                </SimpleItem>

                                <SimpleItem dataField="breakTime" label={{text: 'Tiempo de descanso'}}
                                            editorType="dxNumberBox" editorOptions={{placeholder: 'Minutos'}}>
                                    <RequiredRule message="Ingrese el tiempo de descanso"/>
                                </SimpleItem>

                                <SimpleItem dataField="rate" label={{text: 'Tarifa'}} editorType="dxNumberBox"
                                            editorOptions={{format: "$ #0.##"}}>
                                    <RequiredRule message="Ingrese la tarifa"/>
                                </SimpleItem>

                                <SimpleItem dataField="commissionRate" label={{text: 'Tarifa de encomienda'}}
                                            editorOptions={{format: "$ #0.##"}} editorType="dxNumberBox">
                                    <RequiredRule message="Ingrese la tarifa de la encomienda"/>
                                </SimpleItem>
                            </GroupItem>
                            <GroupItem colCount={2}>

                                <SimpleItem dataField="days" label={{text: 'Días'}} editorType="dxSelectBox"
                                            editorOptions={{
                                                items: days,
                                                searchEnabled: true,
                                                placeholder: 'Seleccionar...',
                                                onItemClick: controlHours
                                            }}>
                                    <RequiredRule message="Seleccione el dia"/>
                                </SimpleItem>

                                <SimpleItem dataField="hour" label={{text: 'Hora'}} editorType="dxDateBox"
                                            editorOptions={{
                                                pickerType: 'native',
                                                type: 'time',
                                                showAnalogClock: true,
                                                placeholder: 'Seleccionar...',
                                                onValueChanged: controlHours
                                            }}>
                                    <RequiredRule message="Seleccione la hora"/>
                                </SimpleItem>
                            </GroupItem>
                            {alert && <GroupItem colCount={1}>
                                <SimpleItem render={renderAlert}/>
                            </GroupItem>}
                            <GroupItem colCount={1}>
                                {success &&
                                <SimpleItem render={renderSuccess}/>
                                }
                            </GroupItem>
                            <GroupItem colCount={2}>
                                <SimpleItem render={renderCancelButton}/>
                                <ButtonItem horizontalAlignment="right" buttonOptions={submitButton}/>
                            </GroupItem>

                        </Form>
                    </form>
                </FormContainer>
            </div>
        </>
    )
}


export default RoutesSchedulesForm